import React, { useEffect, useState } from 'react';
import PageLayout from '../components/Layout';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import '../css/error.css';
import EColourPanel from '../interfaces/EColourPanel';
import { HOME_URL } from '../const/URL.const';
import { useHistory } from 'react-router-dom';

interface IErrorHistoryState {
    disabled?: boolean;
    error?: Error;
}

const ErrorContainer = () => {
    const { t } = useTranslation();
    const [stack, setStack] = useState<string | undefined>();
    const [message, setMessage] = useState("UNKNOWN ERROR");
    const history = useHistory();
    // const [disabled, setDisabled] = useState(true);
    useEffect(() => {
        //@ts-ignore
        setErrorState(history.location.state);
    });
    const setErrorState = (locState: IErrorHistoryState | undefined | null) => {
        if (locState !== undefined && locState !== null) {
            if (locState.error) {
                if (locState.error.stack) {
                    setStack(locState.error.stack);
                }
                setMessage(locState.error.message);
            }
            // if (locState.disabled !== undefined) {
            //     setDisabled(locState.disabled);
            // }
        }
    };
    return <PageLayout showHeader={true} title={t('errors.errorcontainer.title')} >
        <div className="errorContainer">
            <p className="errorinfo">{t('errors.errorcontainer.info')}</p>

            <p>{t('errors.errorcontainer.errormsg')}: {message}</p>

            {stack && <p>{stack}</p>}

            <Button variant="contained" onClick={() => history.push(HOME_URL)} style={{ float: "left" }} color={EColourPanel.PRIMARY}>
                {t('misc.goback')} to login
            </Button>
            
            <Button variant="contained" onClick={history.goBack} style={{ float: "right" }} color={EColourPanel.PRIMARY}>
                {t('misc.goback')}
            </Button>
        </div>
    </PageLayout >;
};

export default ErrorContainer;